export default __webpack_public_path__ + "static/offerings3-84ff4752772d520204f40a0c7a5dd29d.jpg";